function dm_c08() {
    const viewer = document.getElementById('globe-model');

    if (!viewer) return;

    let lastScroll = 0;
    let rotation = 0;
    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;
        const delta = currentScroll - lastScroll;

        rotation += delta * 0.2;

        if (rotation > 360) rotation -= 360;
        if (rotation < 0) rotation += 360;

        viewer.cameraOrbit = `${rotation}deg 75deg 105%`;
        lastScroll = currentScroll;
    });
}

export { dm_c08 };
